import { useState, useEffect } from "react";
import { useApi } from "../../utils/api/useApi";
import { CountryDto } from "../../models/countryDto";
import { countriesEndpoint } from "../../utils/api/urls";
import { useTranslation } from "../useTranslationHook/useTranslation";

export const useCountries = () => {
  const [countries, setCountries] = useState<CountryDto[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApi<CountryDto[]>();
  const { translateId, locale } = useTranslation();

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await get(countriesEndpoint);

        const translatedData = data.map((country) => {
          const code = country.twoLetterCode.code?.toUpperCase() ?? "";
          const id = `COUNTRY.${code}`;
          return {
            ...country,
            name: translateId(id)
          };
        });

        setCountries(translatedData);
      } catch (err: any) {
        setError(err.message || "Error fetching countries.");
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, [get, translateId, locale]);

  return { countries, loading, error };
};
